class GuestUserController {
  constructor($scope,$uibModalInstance, optionsModal) {
    this.$uibModalInstance = $uibModalInstance;
    this.$scope = $scope;
    this.optionsModal = optionsModal;
  }


  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  selectThird() {
    if(this.guestUserForm.$valid){
      this.$uibModalInstance.close(this.user);
    } else {
      this.guestUserForm.contactoNombre.$setDirty();
      this.guestUserForm.contactoEmail.$setDirty();
      this.guestUserForm.contactoTelefono.$setDirty();
      this.guestUserForm.contactoDireccion.$setDirty();
      this.guestUserForm.contactoNombreCiudad.$setDirty();
    }
  }
}

GuestUserController.$inject = ['$scope', '$uibModalInstance', 'optionsModal'];

export default GuestUserController;



/** WEBPACK FOOTER **
 ** ./www/components/cart/modal-logistic/modal-logistic.controller.js
 **/